import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule, ModalController} from '@ionic/angular';
import {TranslocoService} from '@jsverse/transloco';
import {TimezoneService} from '../../../services/mygreencountry/timezone.service';

@Component({
    selector: 'app-timezone-modal', standalone: true,
    imports: [CommonModule, FormsModule, IonicModule],
    templateUrl: './timezone-modal.component.html', styleUrls: ['./timezone-modal.component.scss']
})
export class TimezoneModalComponent {
    @Input() automatic = false;
    @Input() studentId: number;
    selected = this.timezones.settings$.value?.timezone || 'Europe/Kyiv';
    detected = this.timezones.detected();
    zones = this.timezones.zones();
    busy = false;
    error = false;
    constructor(public timezones: TimezoneService, private modal: ModalController, private locale: TranslocoService) {}
    text(uk: string, en: string): string { return this.locale.getActiveLang() === 'en' ? en : uk; }
    close(): void { if (!this.busy) void this.modal.dismiss(); }
    save(zone: string): void {
        if (this.busy) return;
        this.busy = true;
        this.error = false;
        this.timezones.save(this.studentId, zone).subscribe({
            next: response => {
                if (!response.success) { this.busy = false; this.error = true; return; }
                void this.modal.dismiss(true, 'saved');
            },
            error: () => { this.busy = false; this.error = true; }
        });
    }
}
